import React from 'react';
import { IonLoading } from '@ionic/react';

export const BarrLoaderSpiner: React.FC = ({spinnerState}:any)=> { 
 
    const { showSpinner, setShowSpinner, durationSpinerToClose }:any = spinnerState;

    return ( 
        <IonLoading
            cssClass='my-custom-class'
            isOpen={showSpinner}
            onDidDismiss={() => setShowSpinner(false)}
            message={'Cargando, espere...'}
            duration={durationSpinerToClose? durationSpinerToClose: 1000}
        /> 
    );
};